import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { useOutletContext } from 'react-router-dom-v5-compat';
import { compose } from 'redux';

import type { FormJobOutletContext } from 'af-root/scenes/Company/Jobs/Form/types';

import { isAllowed } from '@acceligentllc/shared/utils/auth';

import type { RootState } from 'af-reducers';

import PagePermissions from 'ab-enums/pagePermissions.enum';

import styles from '../styles.module.scss';
import EnvironmentalProtectionSection from './Sections/EnvironmentalProtectionSection';
import JobHazardSummarySection from './Sections/JobHazardSummarySection';
import PermitsRequiredSection from './Sections/PermitsRequired';
import PublicSafetySection from './Sections/PublicSafetySection';
import SafetySection from './Sections/SafetySection';
import StatusSection from './Sections/StatusSection';

type Props = ConnectedProps<typeof connector>;

const JobHazardAssessmentFormTab: React.FC<Props> = (props) => {
	const { hasManageJobPermission } = props;
	const { change, formName } = useOutletContext<FormJobOutletContext>();
	const jobHazzardSummaryRef = React.useRef<Nullable<HTMLDivElement>>(null);

	React.useEffect(() => {
		if (jobHazzardSummaryRef.current) {
			jobHazzardSummaryRef.current.scrollIntoView({ block: 'end' });
		}
	}, []);

	return (
		<div className={styles['job-form__tab-content']}>
			<JobHazardSummarySection isDisabled={!hasManageJobPermission} jobHazzardSummaryRef={jobHazzardSummaryRef} />
			<PermitsRequiredSection isDisabled={!hasManageJobPermission} />
			<SafetySection isDisabled={!hasManageJobPermission} />
			<EnvironmentalProtectionSection isDisabled={!hasManageJobPermission} />
			<PublicSafetySection isDisabled={!hasManageJobPermission} />
			<StatusSection change={change} formName={formName} isDisabled={!hasManageJobPermission} />
		</div>
	);
};

function mapStateToProps(state: RootState) {
	const { user: { companyData, userData } } = state;
	if (!userData || !companyData) {
		throw new Error('User not logged in');
	}

	const hasManageJobPermission = isAllowed(PagePermissions.COMPANY.JOBS.MANAGE_JOBS, companyData.permissions, companyData.isCompanyAdmin, userData.role);

	return {
		hasManageJobPermission,
	};
}

const connector = connect(mapStateToProps, null);

const enhance = compose<React.ComponentType>(
	React.memo,
	connector
);

export default enhance(JobHazardAssessmentFormTab);
